import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';
import type { Database } from '../types/supabase';

export type UpdateSubscriptionInput =
  Database['public']['Tables']['company_subscriptions']['Update'] & {
    id: string;
  };

export function useUpdateSubscription() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, ...data }: UpdateSubscriptionInput) => {
      const { data: updated, error } = await supabase
        .from('company_subscriptions')
        .update(data)
        .eq('id', id)
        .select()
        .single();

      if (error) throw error;
      return updated;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['company-subscriptions'] });
    },
  });
}
